import type {StateCreator} from 'zustand'
import type {UnifiedBatchSlice} from './unified-batch'

export interface ComparisonOutdatedSlice {
  /**
   * Indicates whether the current comparison (base/head OIDs) is up to date.
   * Becomes false when there are pushes to the pull request that change the base or head commit and the user
   * has not yet refreshed the comparison.
   */
  isComparisonOutdated: boolean
  comparisonOutdatedActions: {
    markComparisonOutdated: () => void
    clearComparisonOutdated: () => void
  }
}

export const createComparisonOutdatedSlice: StateCreator<
  ComparisonOutdatedSlice & UnifiedBatchSlice,
  [['zustand/devtools', never]],
  [],
  ComparisonOutdatedSlice
> = (set, get) => ({
  isComparisonOutdated: false,
  comparisonOutdatedActions: {
    markComparisonOutdated: () => {
      set(
        () => ({
          isComparisonOutdated: true,
        }),
        undefined,
        'comparisonOutdated#markComparisonOutdated',
      )
      // A push that outdates the comparison also outdates every batched item.
      // The action is a no-op when the unified-batch flag is off.
      get().unifiedBatchActions.markAllOutdated()
    },
    clearComparisonOutdated: () =>
      set(
        () => ({
          isComparisonOutdated: false,
        }),
        undefined,
        'comparisonOutdated#clearComparisonOutdated',
      ),
  },
})
